import plainObject from 'is-plain-object';

export const allFalse = (object) => {
    let i;
    for (i in object) {
        if (object.hasOwnProperty(i)) {
            if (object[i].value === undefined) return false;
        }
    }
    return true;
};

export const is = require('is');

is.plainObject = plainObject;


export const firstLetterUpperCaseNoDashes = (str) => {
    const frags = str.split('_');
    frags.forEach((frag, index) => frags[index] = frag.charAt(0)
        .toUpperCase() + frag.slice(1));
    return frags[0] === 'Ref' ? frags.join(' ')
        .substr(4) : frags.join(' ');
};

export const digitAndDashValidation = value => /^\d+$/.test(value);

export const phoneNumberClearValue = str => str.split('-')
    .join('');

export const firstLetterLowCase = str => str.charAt(0)
    .toLowerCase() + str.substr(1);

export const firstLetterUpperCase = str => (str !== null ? str.charAt(0)
    .toUpperCase() + str.substr(1) : '');
export const get = (obj, key) => key.split('.')
    .reduce((o, x) => ((typeof o === 'undefined' || o === null) ? o : o[x]), obj);

export const trim = value => value.replace(/ /g, '');

export const each = (obj, callback) => {
    if (Array.isArray(obj)) {
        const { length } = obj;
        for (let index = 0; index < length; index++) {
            if (callback.call(obj[index], index, obj[index]) === false) {
                break;
            }
        }
    } else {
        for (const key in obj) {
            if (callback.call(obj[key], key, obj[key]) === false) {
                break;
            }
        }
    }
    return obj;
};

export const debounce = function debounce(func, wait, immediate) {
    let timeout;

    return function () {
        const context = this; const
            args = arguments;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export const getVal = (obj, key) => key.split('.')
    .reduce((o, x) => ((typeof o === 'undefined' || o === null) ? o : o[x]), obj);

export const setVal = (target, required_path, value) => {
    if (typeof required_path === 'string') required_path = required_path.split('.');

    const required_key = required_path.shift();

    if (required_path.length) {
        if (!target[required_key] || (target[required_key] && typeof target[required_key] !== 'object')) target[required_key] = {};
        setVal(target[required_key], required_path, value);
    } else {
        target[required_key] = value;
    }

    return target;
};

export const checkLeadReject = _id => !/5beabe6d66676f89160edd7f|5beabef666676f89160edfbf|5beabf6166676f89160edfc0|5beabf6166676f89160edfc1|5beabf6166676f89160edfc2|5beabf6166676f89160edfc3|5beabf6166676f89160edfc4|5beabf6166676f89160edfc5|5beabf6166676f89160edfc6|5beabf6166676f89160edfc7|5beabf6166676f89160edfc8|5beac00ef25bf5f49685abfe|5beac062f25bf5f49685abff|5beac062f25bf5f49685ac00|5beac063f25bf5f49685ac01|5beac063f25bf5f49685ac02|5beac063f25bf5f49685ac03|5beac063f25bf5f49685ac04/.test(_id);

// --- USER GROUP UPDATE MODULE ---

export const checkStatus = option => option.modulePermissions && !!option.modulePermissions.permissions.length;

export const checkStatuses = (options, model) => {
    let status;
    if (options !== null) {
        if (!Array.isArray(options)) {
            if (model === 'models') {
                Object.keys(options)
                    .map(option => options[option].modulesPermissions)
                    .forEach(el => Object.keys(el)
                        .every(option => status = !!el[option].permissions.length));
            } else {
                status = Object.keys(options)
                    .map(option => options[option].modulesPermissions)
                    .every(option => !!option.permissions);
            }
        } else {
            status = options.every(option => option.modulePermissions && option.modulePermissions.permissions.length);
        }
    }
    return status;
};

export const choose_permissions = (option, status) => {
    if (option === 'classMethods') {
        if (!status) {
            return [];
        }
        return ['x'];
    } if (option === 'views') {
        if (!status) {
            return [];
        }
        return ['r'];
    } if (option === 'module') {
        if (!status) {
            return [];
        }
        return ['r'];
    }
    if (!status) {
        return [];
    }

    return ['c', 'r', 'u', 'd'];
};

export const isExist = (fields) => {
    if (Array.isArray(fields)) {
        return !!fields.length;
    } if (fields === null) {
        return false;
    }
    return fields.size !== 0;
};

export const checkFieldStatus = (system_crud, option, permissions) => {
    if (!permissions.length) return false;

    if (system_crud[firstLetterLowCase(option.title)]) {
        return permissions.includes(firstLetterLowCase(option.title[0]));
    }
};

// ----------------------------------

export const isNumber = n => !isNaN(parseFloat(n)) && isFinite(n);

export const isBoolean = val => val === true || val === false;

// Stolen from backend
export const extend = function () {
    let options; let name; let src; let copy; let copyIsArray; let clone;
    let target = arguments[0] || {};
    let i = 1;
    const { length } = arguments;
    let deep = false;

    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;

        // Skip the boolean and the target
        target = arguments[i] || {};
        i++;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== 'object' && !is.function(target)) {
        target = {};
    }


    // Extend jQuery itself if only one argument is passed
    if (i === length) {
        target = this;
        i--;
    }

    for (; i < length; i++) {
        // Only deal with non-null/undefined values
        if ((options = arguments[i]) !== null) {
            // Extend the base object
            for (name in options) {
                src = target[name];
                copy = options[name];

                // Prevent never-ending loop
                if (target === copy) {
                    continue;
                }

                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (is.plainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && Array.isArray(src) ? src : [];
                    } else {
                        clone = src && is.plainObject(src) ? src : {};
                    }

                    // Never move original objects, clone them
                    target[name] = extend(deep, clone, copy);

                    // Don't bring in undefined values
                } else if (copy !== undefined) {
                    target[name] = copy;
                }
            }
        }
    }

    // Return the modified object
    return target;
};

export const deleteKeyFromObject = (obj, keysArr) => {
    if (!is.plainObject(obj)) return {};
    const newObject = Object.keys(obj)
        .reduce(
            (newObj, key) => {
                const keyNotFromKeyArr = !keysArr.includes(key);
                if (keyNotFromKeyArr) {
                    newObj[key] = obj[key];
                }
                return newObj;
            }, {},
        );
    return newObject;
};

// BE returns errors in different formats
export const getErrorMessage = (error) =>  error.response?.data?.message || error.message || error.error.message;



// WEBPACK FOOTER //
// ./src/shared/helpers.js